import * as React from "react";
import { IFGCheckboxInputProps, FGCheckboxInput } from "nsitools-react";
import { Colors } from "@blueprintjs/core";

export interface IFGSRSHCheckboxInput extends IFGCheckboxInputProps {}

export const FGSRSHCheckboxInput: React.FunctionComponent<IFGSRSHCheckboxInput> = ({
  colorTick = Colors.GREEN5,
  colorCross = Colors.RED5,
  ...cProps
}) => {
  return <FGCheckboxInput {...cProps} colorTick={colorTick} colorCross={colorCross} />;
};
